/** Default idle timeout aligned with server session cookie maxAge (10 minutes). */
const DEFAULT_SESSION_TIMEOUT_MINUTES = 10;

/** How long before expiry the warning modal is shown. */
const DEFAULT_WARNING_LEAD_MINUTES = 2;

const parsePositiveMinutes = (value: string | undefined): number | null => {
  if (!value) {
    return null;
  }

  const minutes = Number(value);
  if (!Number.isFinite(minutes) || minutes <= 0) {
    return null;
  }

  return minutes;
};

export const getSessionTimeoutMs = (): number => {
  const minutes = parsePositiveMinutes(import.meta.env.VITE_SESSION_TIMEOUT_MINUTES);

  return (minutes ?? DEFAULT_SESSION_TIMEOUT_MINUTES) * 60 * 1000;
};

export const getSessionWarningLeadMs = (): number => {
  const minutes = parsePositiveMinutes(import.meta.env.VITE_SESSION_WARNING_MINUTES);

  return (minutes ?? DEFAULT_WARNING_LEAD_MINUTES) * 60 * 1000;
};

export const SESSION_ACTIVITY_EVENTS = ['mousedown', 'keydown', 'scroll', 'touchstart', 'click'] as const;
